import { render } from "./RequestDetail.vue?vue&type=template&id=719d4eb4&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=js"
export * from "./RequestDetail.vue?vue&type=script&lang=js"

import "./RequestDetail.vue?vue&type=style&index=0&id=719d4eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719d4eb4"]])

export default __exports__